import React from "react";
import SEO from "@/components/SEO";
import LocationTemplate from "@/components/LocationTemplate";

const KalkalloPage = () => <LocationTemplate suburbName="Kalkallo" suburbSlug="kalkallo" />;

export default KalkalloPage;
